import apiClient, { apiFormClient } from "../utils/apiClient";

export const getHistoryStatistics = async () => {
    try {
        const response = await apiClient.get('/api/tai-lieu-van-hoa/statistics');
        if (response.data.success) return response.data.data;
        return null;
    } catch (error) {
        return null;
    }
};

export const getHistoryDocuments = async (params = {}) => {
    try {
        const response = await apiClient.get('/api/tai-lieu-van-hoa/paging', { params });
        if (response.data.success) return response.data;
        return { data: [], pagination: null };
    } catch (error) {
        return { data: [], pagination: null };
    }
};

export const getHistoryDocumentDetail = async (id) => {
    try {
        const response = await apiClient.get(`/api/tai-lieu-van-hoa/${id}`);
        if (response.data.success) return response.data.data;
        return null;
    } catch (error) {
        return null;
    }
};

export const getHistorySubCategories = async () => {
    try {
        const response = await apiClient.get('/api/tai-lieu-van-hoa/sub-categories');
        if (response.data.success) return response.data.data;
        return [];
    } catch (error) {
        return [];
    }
};

export const createHistoryDocument = async (formData) => {
    try {
        const response = await apiFormClient.post('/api/tai-lieu-van-hoa', formData);
        if (response.data.success) return { success: true, data: response.data.data };
        return { success: false, error: 'Tạo tài liệu thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Tạo tài liệu thất bại';
        return { success: false, error: message };
    }
};

export const updateHistoryDocument = async (id, formData) => {
    try {
        if (formData instanceof FormData) {
            formData.delete('trangThai');
            formData.delete('trang_thai');
        }
        const response = await apiFormClient.put(`/api/tai-lieu-van-hoa/${id}`, formData);
        if (response.data.success) return { success: true, data: response.data.data };
        return { success: false, error: response.data.message || 'Cập nhật tài liệu thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Cập nhật tài liệu thất bại';
        return { success: false, error: message };
    }
};

export const deleteHistoryDocument = async (id, lyDoXoa) => {
    try {
        const response = await apiClient.delete(`/api/tai-lieu-van-hoa/${id}`, {
            data: { lyDoXoa }
        });
        if (response.data.success) return { success: true };
        return { success: false, error: 'Xóa tài liệu thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Xóa tài liệu thất bại';
        return { success: false, error: message };
    }
};

export const updateHistoryDocumentStatus = async (id, trangThai) => {
    try {
        const response = await apiClient.put(`/api/tai-lieu-van-hoa/update-status/${id}`, { trangThai });
        if (response.data.success) return { success: true, data: response.data.data };
        return { success: false, error: response.data.message || 'Cập nhật trạng thái thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Cập nhật trạng thái thất bại';
        return { success: false, error: message };
    }
};

export const approveHistoryDocument = async (id) => {
    try {
        const response = await apiClient.put(`/api/tai-lieu-van-hoa/approve/${id}`);
        if (response.data.success) return { success: true, data: response.data.data };
        return { success: false, error: response.data.message || 'Phê duyệt tài liệu thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Phê duyệt tài liệu thất bại';
        return { success: false, error: message };
    }
};

export const rejectHistoryDocument = async (id, lyDoTuChoi = '') => {
    try {
        const payload = lyDoTuChoi && lyDoTuChoi.trim() ? { lyDoTuChoi: lyDoTuChoi.trim() } : { lyDoTuChoi: null };
        const response = await apiClient.put(`/api/tai-lieu-van-hoa/reject/${id}`, payload);
        if (response.data.success) return { success: true, data: response.data.data };
        return { success: false, error: response.data.message || 'Từ chối tài liệu thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Từ chối tài liệu thất bại';
        return { success: false, error: message };
    }
};

export const unapproveHistoryDocument = async (id) => {
    try {
        const response = await apiClient.put(`/api/tai-lieu-van-hoa/unapprove/${id}`);
        if (response.data.success) return { success: true, data: response.data.data };
        return { success: false, error: response.data.message || 'Hoàn tác phê duyệt thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Hoàn tác phê duyệt thất bại';
        return { success: false, error: message };
    }
};

export const aiLearnHistoryDocument = async (id, action = 'learn') => {
    try {
        const response = await apiClient.post(`/api/tai-lieu-van-hoa/ai-learn/${id}`, { action });
        if (response.data.success) return { success: true, data: response.data.data };
        return { success: false, error: response.data.message || 'Thao tác AI thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Thao tác AI thất bại';
        return { success: false, error: message };
    }
};

export const getHistoryDeletedDocuments = async (params = {}) => {
    try {
        const response = await apiClient.get('/api/tai-lieu-van-hoa/deleted', { params });
        if (response.data.success) return response.data;
        return { data: [], pagination: null };
    } catch (error) {
        return { data: [], pagination: null };
    }
};

export const restoreHistoryDocument = async (id) => {
    try {
        const response = await apiClient.put(`/api/tai-lieu-van-hoa/restore/${id}`);
        if (response.data.success) return { success: true, data: response.data.data, message: response.data.message };
        return { success: false, error: response.data.message || 'Khôi phục tài liệu thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Khôi phục tài liệu thất bại';
        return { success: false, error: message };
    }
};

export const forceDeleteHistoryDocument = async (id) => {
    try {
        const response = await apiClient.delete(`/api/tai-lieu-van-hoa/force/${id}`);
        if (response.data.success) return { success: true, data: response.data.data, message: response.data.message };
        return { success: false, error: response.data.message || 'Xóa vĩnh viễn tài liệu thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Xóa vĩnh viễn tài liệu thất bại';
        return { success: false, error: message };
    }
};

/* ==========================================================================
   TÀI LIỆU QUY PHẠM PHÁP LUẬT APIs (/api/tai-lieu-phap-luat)
   ========================================================================== */

export const getLegalStatistics = async () => {
    try {
        const response = await apiClient.get('/api/tai-lieu-phap-luat/statistics');
        if (response.data.success) return response.data.data;
        return null;
    } catch (error) {
        return null;
    }
};

export const getLegalDocuments = async (params = {}) => {
    try {
        const response = await apiClient.get('/api/tai-lieu-phap-luat/paging', { params });
        if (response.data.success) return response.data;
        return { data: [], pagination: null };
    } catch (error) {
        return { data: [], pagination: null };
    }
};

export const getLegalDocumentDetail = async (id) => {
    try {
        const response = await apiClient.get(`/api/tai-lieu-phap-luat/${id}`);
        if (response.data.success) return response.data.data;
        return null;
    } catch (error) {
        return null;
    }
};

export const getLegalDocTypes = async () => {
    try {
        const response = await apiClient.get('/api/tai-lieu-phap-luat/doc-types');
        if (response.data.success) return response.data.data;
        return [];
    } catch (error) {
        return [];
    }
};

export const getLegalIssuingAgencies = async () => {
    try {
        const response = await apiClient.get('/api/tai-lieu-phap-luat/issuing-agencies');
        if (response.data.success) return response.data.data;
        return [];
    } catch (error) {
        return [];
    }
};

export const createLegalDocument = async (formData) => {
    try {
        const response = await apiFormClient.post('/api/tai-lieu-phap-luat', formData);
        if (response.data.success) return { success: true, data: response.data.data };
        return { success: false, error: response.data.message || 'Tạo tài liệu pháp luật thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Tạo tài liệu pháp luật thất bại';
        return { success: false, error: message };
    }
};

export const updateLegalDocument = async (id, formData) => {
    try {
        if (formData instanceof FormData) {
            formData.delete('trangThai');
            formData.delete('trang_thai');
        }
        const response = await apiFormClient.put(`/api/tai-lieu-phap-luat/${id}`, formData);
        if (response.data.success) return { success: true, data: response.data.data };
        return { success: false, error: response.data.message || 'Cập nhật tài liệu pháp luật thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Cập nhật tài liệu pháp luật thất bại';
        return { success: false, error: message };
    }
};

export const deleteLegalDocument = async (id, lyDoXoa) => {
    try {
        const response = await apiClient.delete(`/api/tai-lieu-phap-luat/${id}`, {
            data: { lyDoXoa }
        });
        if (response.data.success) return { success: true };
        return { success: false, error: response.data.message || 'Xóa tài liệu pháp luật thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Xóa tài liệu pháp luật thất bại';
        return { success: false, error: message };
    }
};

export const updateLegalDocumentStatus = async (id, trangThai) => {
    try {
        const response = await apiClient.put(`/api/tai-lieu-phap-luat/update-status/${id}`, { trangThai });
        if (response.data.success) return { success: true, data: response.data.data };
        return { success: false, error: response.data.message || 'Cập nhật trạng thái thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Cập nhật trạng thái thất bại';
        return { success: false, error: message };
    }
};

export const approveLegalDocument = async (id) => {
    try {
        const response = await apiClient.put(`/api/tai-lieu-phap-luat/approve/${id}`);
        if (response.data.success) return { success: true, data: response.data.data };
        return { success: false, error: response.data.message || 'Phê duyệt tài liệu thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Phê duyệt tài liệu thất bại';
        return { success: false, error: message };
    }
};

export const rejectLegalDocument = async (id, lyDoTuChoi = '') => {
    try {
        const payload = lyDoTuChoi && lyDoTuChoi.trim() ? { lyDoTuChoi: lyDoTuChoi.trim() } : { lyDoTuChoi: null };
        const response = await apiClient.put(`/api/tai-lieu-phap-luat/reject/${id}`, payload);
        if (response.data.success) return { success: true, data: response.data.data };
        return { success: false, error: response.data.message || 'Từ chối tài liệu thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Từ chối tài liệu thất bại';
        return { success: false, error: message };
    }
};

export const unapproveLegalDocument = async (id) => {
    try {
        const response = await apiClient.put(`/api/tai-lieu-phap-luat/unapprove/${id}`);
        if (response.data.success) return { success: true, data: response.data.data };
        return { success: false, error: response.data.message || 'Hoàn tác phê duyệt thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Hoàn tác phê duyệt thất bại';
        return { success: false, error: message };
    }
};

export const aiLearnLegalDocument = async (id, action = 'learn') => {
    try {
        const response = await apiClient.post(`/api/tai-lieu-phap-luat/ai-learn/${id}`, { action });
        if (response.data.success) return { success: true, data: response.data.data };
        return { success: false, error: response.data.message || 'Thao tác AI thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Thao tác AI thất bại';
        return { success: false, error: message };
    }
};

export const getLegalDeletedDocuments = async (params = {}) => {
    try {
        const response = await apiClient.get('/api/tai-lieu-phap-luat/deleted', { params });
        if (response.data.success) return response.data;
        return { data: [], pagination: null };
    } catch (error) {
        return { data: [], pagination: null };
    }
};

export const restoreLegalDocument = async (id) => {
    try {
        const response = await apiClient.put(`/api/tai-lieu-phap-luat/restore/${id}`);
        if (response.data.success) return { success: true, data: response.data.data, message: response.data.message };
        return { success: false, error: response.data.message || 'Khôi phục tài liệu thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Khôi phục tài liệu thất bại';
        return { success: false, error: message };
    }
};

export const forceDeleteLegalDocument = async (id) => {
    try {
        const response = await apiClient.delete(`/api/tai-lieu-phap-luat/force/${id}`);
        if (response.data.success) return { success: true, data: response.data.data, message: response.data.message };
        return { success: false, error: response.data.message || 'Xóa vĩnh viễn tài liệu thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Xóa vĩnh viễn tài liệu thất bại';
        return { success: false, error: message };
    }
};

export const downloadLegalDocument = async (id) => {
    try {
        const response = await apiClient.get(`/api/tai-lieu-phap-luat/${id}/download`);
        if (response.data.success) return { success: true, data: response.data.data };
        return { success: false, error: response.data.message || 'Lấy thông tin tải xuống thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Lấy thông tin tải xuống thất bại';
        return { success: false, error: message };
    }
};

export const downloadHistoryDocument = async (id) => {
    try {
        const response = await apiClient.get(`/api/tai-lieu-van-hoa/${id}/download`);
        if (response.data.success) return { success: true, data: response.data.data };
        return { success: false, error: response.data.message || 'Lấy thông tin tải xuống thất bại' };
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Lấy thông tin tải xuống thất bại';
        return { success: false, error: message };
    }
};

export const exportHistoryDocuments = async (params = {}) => {
    try {
        const response = await apiClient.get('/api/tai-lieu-van-hoa/export', {
            params,
            responseType: 'blob',
        });
        return { success: true, data: response.data };
    } catch (error) {
        let message = 'Xuất file Excel thất bại';
        if (error.response?.data instanceof Blob) {
            try {
                const text = await error.response.data.text();
                const json = JSON.parse(text);
                if (json.message) message = json.message;
            } catch {}
        } else if (error.response?.data?.message) {
            message = error.response.data.message;
        }
        return { success: false, error: message };
    }
};

export const exportLegalDocuments = async (params = {}) => {
    try {
        const response = await apiClient.get('/api/tai-lieu-phap-luat/export', {
            params,
            responseType: 'blob',
        });
        return { success: true, data: response.data };
    } catch (error) {
        let message = 'Xuất file Excel thất bại';
        if (error.response?.data instanceof Blob) {
            try {
                const text = await error.response.data.text();
                const json = JSON.parse(text);
                if (json.message) message = json.message;
            } catch {}
        } else if (error.response?.data?.message) {
            message = error.response.data.message;
        }
        return { success: false, error: message };
    }
};